import React, { useState } from 'react';
import { withStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import styles from '../styles';
import PF2MTabs from '~/components/PF2MTabs';
import SieveTab from './SieveTab';
import MaterialSpecsTab from './MaterialSpecsTab';
import AnalysisTab from './AnalysisTab';

const Granulometry = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const { t: translate } = useTranslation();

  const tabs = [
    { key: 0, label: translate('common:Sieve') },
    { key: 1, label: translate('common:MaterialSpecifications') },
    { key: 2, label: translate('common:AssociationRegistry') },
  ];

  const handleChange = (event, value) => setSelectedTab(value);

  return (
    <>
      <PF2MTabs
        value={selectedTab}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
      >
        {tabs}
      </PF2MTabs>
      {selectedTab === 0 ? (<SieveTab />) : null}
      {selectedTab === 1 ? (<MaterialSpecsTab />) : null}
      {selectedTab === 2 ? (<AnalysisTab />) : null}
    </>
  );
};

export default withStyles(styles)(Granulometry);
